import { render } from "./down-product.vue?vue&type=template&id=7d6822ea"
import script from "./down-product.vue?vue&type=script&lang=js"
export * from "./down-product.vue?vue&type=script&lang=js"

import "./down-product.vue?vue&type=style&index=0&id=7d6822ea&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__